import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  tags: [],
};

const getters = {
  // Tag
  tags: state => state.tags.sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  tagsAtivo: state => state.tags.filter(t => t.Status.startsWith('A')).sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  // Tag
  async fetchTags({ commit }) {
    const response = await axios.get(`${baseUrl}/tags`);
    if (response.data.length) {
      commit('setTags', response.data);
    } else {
      commit('setTags', []);
    }
  },
  async fetchTagsSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/tags?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setTags', response.data);
      } else {
        commit('setTags', []);
      }
    } catch (error) {
      commit('setTags', []);
    }
  },
  async addTag({ commit }, tag) {
    const response = await axios.post(`${baseUrl}/tags`, tag, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    tag.IdTag = response.data.IdTag;
    commit('newTag', tag);
    return response.data.IdTag;
  },
  async updateTag({ commit }, updTag) {
    await axios.put(`${baseUrl}/tags`, updTag, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateTag', updTag);
  },
  async deleteTag({ commit }, id) {
    await axios.delete(`${baseUrl}/tags/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeTag', id);
  },
}

const mutations = {
  // Tag
  setTags: (state, tags) => state.tags = tags,
  newTag: (state, tag) => state.tags.push(tag),
  removeTag: (state, id) => state.tags = state.tags.filter(tag => tag.IdTag !== id),
  updateTag: (state, updTag) => {
    const index = state.tags.findIndex(tag => tag.IdTag === updTag.IdTag);
    if (index !== -1) {
      state.tags.splice(index, 1, updTag);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}